import React from 'react';
import { Item, ItemProps } from './Item';
import styles from './List.module.scss';

interface Props {
  children: React.ReactNode;
}

interface ListProps {
  Item: React.FC<ItemProps>;
}

const List: React.FC<Props> & ListProps = ({ children }) => (
  <ul className={styles.wrapper} role='navigation'>
    {children}
  </ul>
);

List.Item = Item;
export default List;
